import React, { useEffect, useState } from "react";
import { ModalBody, ModalFooter } from "@vds/modals";
import { Button } from "@vds/buttons";
import styled from "styled-components";

import { Icon } from "@vds/icons";
import AscendingSortIcon from "../../assets/icons/sort-ascending.png";
import DescendingSortIcon from "../../assets/icons/sort-descending.png";
import DownArrowIcon from "../../assets/icons/down-arrow.svg";
import UpArrowIcon from "../../assets/icons/up-arrow.svg";
import NoSort from "../../assets/icons/no-sort.png";

import Pagination from "react-js-pagination";
import "./paymentHistory.css";

import * as StyledTableCSS from "../../constants/common/StyledTableConstants";
import * as StyledPaginationCSS from "../../constants/common/StyledPaginationConstants";

import { connect } from "react-redux";

import * as Actions from "../../store/actions/billing/paymentHistoryAction";

import { Loader } from "@vds/loaders";
import * as dateFormat from "../../util/dateUtils";
import { addCurrencySymbol } from "../../util/negativeAmountHandler";

import { setAlertState } from "../../util/util";
import { dateToday, dateTwoYearsAgo } from "../../util/billingUtils";
import { useTranslation } from "react-i18next";
import DateFilter from "../cases/DateFilter";
import {
  Wrapper,
  ModalBox,
  SortIconStylePayment as SortIconStyle,
  SortIconStyle_1_Payment as SortIconStyle1,
  CPButton,
} from "../../constants/common/StyledGlobalConstants";
import { dateConversion, getDateFormat, handleDateTimeZone } from "../../util/dateUtils";
import { Grid } from "@vds/grids";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

const MediumTextTableHeader = styled.th`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  font-family: neue-haas-grotesk-text, Helvetica, Ariel;
  width: 24%;
  @media (max-width: 1023px) {
    width: 31%;
    font-size: 0.75rem;
  }
  @media (min-width: 1024px) {
    font-size: 0.875rem;
    font-family: neue-haas-grotesk-text;
  }
`;

const ArrowIconStyle = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 0.3125rem;
  cursor: pointer;
`;

const MediumTextTableBody = styled.td`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  font-family: neue-haas-grotesk-text, Helvetica, Ariel;
  width: 24%;
  @media (max-width: 1023px) {
    width: 31%;
    font-size: 0.75rem;
  }
  @media (min-width: 1024px) {
    font-family: neue-haas-grotesk-text;
  }
`;

const CustomWrapper = styled(StyledTableCSS.CustomWrapper)`
  display: flex;
  gap: 16px;
  @media (max-width: 1023px) {
    margin-top: 1.5rem;
  }
  @media (min-width: 361px) {
    margin-top: 1.5rem;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    & button {
      margin-top: auto;
    }
  }
`;

// Helper function to convert date formats for non-US regions
const convertDateFormatForRegion = (dateString, regionId) => {
  if (regionId === "840" || regionId === "124") {
    return dateString;
  } else if (regionId === "36" || regionId === "554") {
    const [dd, mm, yyyy] = dateString.split("/");
    dateString = `${mm}/${dd}/${yyyy}`;
  } else {
    const [dd, mm, yyyy] = dateString.split(".");
    dateString = `${mm}/${dd}/${yyyy}`;
  }
  return dateString;
};

function ManagePaymentHistory(props) {
  const [pageRangeDisplayed] = useState(5);
  const [accordianArray, setAccordianArray] = useState([]);
  const tableSearchRef = React.createRef();
  const { t } = useTranslation("billingTranslation");

  useEffect(() => {
    window.newrelic?.addPageAction("PaymentHistoryTab", { value: "PaymentHistoryTab" });
  }, []);

  useEffect(() => {
    if (props.paymentHistoryTab === 1) {
      if (props.contractAccount) {
        props.makePaymentHistoryCall && props.load(props.contractAccount);
      } else {
        props.reset();
      }
    }
  }, [props.paymentHistoryTab]);

  useEffect(() => {
    handleLoadTableData(props.recordsPerPage, props.actionName, props.transactionList);
  }, [props.recordsPerPage, props.actionName, JSON.stringify(props.transactionList), JSON.stringify(props.filteredData), props.activePage]);

  const handleLoadTableData = (perPage, actionName, data) => {
    const lastRecordIndex = props.activePage * props.recordsPerPage;
    const firstRecordIndex = lastRecordIndex - props.recordsPerPage;
    let slicedData = [];
    let inputData;
    if (actionName === "onLoad") {
      let fromDate = dateFormat.dateRangeFormat(props.dateFrom);
      let toDate = dateFormat.dateRangeFormat(props.dateTo);
      let from = new Date(fromDate);
      from.setHours(0, 0, 0);
      let to = new Date(toDate);
      to.setHours(23, 59, 59);
      let dataFilteredByDate = props.transactionList.filter((history) => {
        let paymentDate = convertDateFormatForRegion(history.paymentDate, props.regionId);
        return new Date(paymentDate) >= from && new Date(paymentDate) <= to;
      });
      inputData = [...dataFilteredByDate];
      props.setFilteredData(dataFilteredByDate);
    } else {
      inputData = [...props.filteredData];
    }
    slicedData = inputData.slice(firstRecordIndex, lastRecordIndex);

    let pageCountValue = Math.ceil(inputData.length / props.recordsPerPage) === 0 ? "" : Math.ceil(inputData.length / props.recordsPerPage);
    props.setPageCount(pageCountValue);
    props.setTotalNumberOfRecords(inputData.length);
    props.setPaymentTableData(slicedData);
  };

  const handlePageChange = (pageNumber) => {
    let number = Number.parseInt(pageNumber);
    props.setActivePage(number);
    props.setPageCount(props.pageCount);
    props.setActionName("others");
  };

  const tableSort = (value, status, statusName) => {
    let result = status === "ascending" ? "descending" : "ascending";
    if (statusName === "sortStatusInvoiceNo") {
      props.setSortStatusInvoiceNo(result);
    }
    if (statusName === "sortStatusPaymentStatus") {
      props.setSortStatusPaymentStatus(result);
    }
    if (status === "ascending") {
      sortFields(value, false);
    } else if (status === "descending") {
      sortFields(value, true);
    } else {
      sortFields(value, true);
    }
    if (statusName != "sortStatusInvoiceNo") {
      props.setSortStatusInvoiceNo("noSort");
    }
    if (statusName != "sortStatusPaymentStatus") {
      props.setSortStatusPaymentStatus("noSort");
    }
  };

  const handleDateFrom = (value) => {
    props.setDateFrom(dateConversion(new Date(value)));
    props.setSearchOrRefresh(true);
  };

  const handleDateTo = (value) => {
    props.setDateTo(dateConversion(new Date(value)));
    props.setSearchOrRefresh(true);
    let fromDate = new Date(props.dateFrom);
    let toDate = new Date(value);
    toDate.setHours(23, 59, 59);
    if (toDate < fromDate) {
      props.setDateTo(dateToday());
    }
  };

  const handleDateRange = () => {
    handleCommon();
    handleCommon("apply");
    tableSearchRef.current.focus();
  };

  const handleDateReset = () => {
    let from = dateTwoYearsAgo();
    let to = dateToday();
    props.setDateFrom(from);
    props.setDateTo(to);
    handleCommon("reset", props.inputValue, from, to);
  };

  const handleCommon = (searchState = "apply", value = props.inputValue, dateFromValue = props.dateFrom, dateToValue = props.dateTo) => {
    props.setSortStatusInvoiceNo("noSort");
    props.setSortStatusTransactionNo("noSort");
    props.setSortStatusPaymentAmount("noSort");
    props.setSortStatusPaymentDate("descending");
    props.setSortStatusPaymentStatus("noSort");
    props.setSortStatusPaymentMode("noSort");
    let filteredData = props.transactionList;
    if (dateFromValue != "" && dateToValue) {
      if (searchState === "apply") props.setSearchOrRefresh(false);
      else props.setSearchOrRefresh(true);
      let fromDate = dateFormat.dateRangeFormat(dateFromValue);
      let toDate = dateFormat.dateRangeFormat(dateToValue);
      let from = new Date(fromDate);
      from.setHours(0, 0, 0);
      let to = new Date(toDate);
      to.setHours(23, 59, 59);
      filteredData = props.transactionList.filter((history) => {
        let paymentDate = convertDateFormatForRegion(history.paymentDate, props.regionId);
        return new Date(paymentDate) >= from && new Date(paymentDate) <= to;
      });
    }
    let searchBasedOn = props.selectedFilterBy;
    let searchResult;
    props.setActivePage(1);
    if (!props.inputValue || props.inputValue.trim().length === 0) {
      searchResult = [...filteredData];
    } else {
      searchResult = filteredData.filter((payment) => {
        if (searchBasedOn === "dueDate") {
          let dateData = dateFormat.handleDateSearch(payment[searchBasedOn]);
          return payment[searchBasedOn] && dateData.includes(props.inputValue.toLowerCase().trim());
        } else {
          return payment[searchBasedOn]?.toString().toLowerCase().includes(props.inputValue.toLowerCase().trim());
        }
      });
    }
    props.setFilteredData(searchResult);
    props.setActionName("others");
  };

  const sortFields = (filterField, status) => {
    let filterPaymentArr = props.filteredData;
    let filteredDataLocal;
    if (filterField === "invoiceNumber") {
      if (status === true) {
        filterPaymentArr.sort(function (b, a) {
          let c = a[filterField].trim().length === 0 ? 0 : Number(a[filterField]);
          let d = b[filterField].trim().length === 0 ? 0 : Number(b[filterField]);
          return d - c;
        });
        filteredDataLocal = filterPaymentArr;
      } else {
        filterPaymentArr.sort(function (a, b) {
          let c = a[filterField].trim().length === 0 ? 0 : Number(a[filterField]);
          let d = b[filterField].trim().length === 0 ? 0 : Number(b[filterField]);

          return d - c;
        });
        filteredDataLocal = filterPaymentArr;
      }
    } else {
      const stringCompare = (first, second) => {
        const firstVal = first[filterField]?.toLowerCase() || "";
        const secondVal = second[filterField]?.toLowerCase() || "";
        if (firstVal < secondVal) {
          return -1;
        } else if (firstVal > secondVal) {
          return 1;
        }
        return 0;
      };
      if (status === true) {
        filterPaymentArr.sort(stringCompare);
        filteredDataLocal = filterPaymentArr;
      } else {
        // Descending sort for string fields
        const descendingCompare = (a, b) => stringCompare(b, a);
        filterPaymentArr.sort(descendingCompare);
        filteredDataLocal = filterPaymentArr;
      }
    }

    props.setFilteredData(filteredDataLocal);
    props.setActionName("onchange");
  };

  const handleErrorModal = (value) => {
    setAlertState(false);
    props.setAlertModal(value);
  };

  const handleAccordianChange = (accordianId) => {
    let AccordianArray = [...accordianArray];
    if (AccordianArray?.includes(accordianId)) {
      AccordianArray = AccordianArray.filter((currentInvoice) => currentInvoice != accordianId);
    } else {
      AccordianArray.push(accordianId);
    }
    setAccordianArray(AccordianArray);
  };

  const windowWidth = props?.windowSize?.width;
  const getResponsiveValues = (width) => {
    let buttonMarginTop;
    if (width < TABLET) {
      buttonMarginTop = "0rem";
    } else if (width >= DESKTOP) {
      buttonMarginTop = "30px";
    } else {
      buttonMarginTop = "auto";
    }
    return {
      paddingTopValue: width < DESKTOP ? "2rem" : undefined,
      okButtonWidth: width < TABLET ? "100%" : "6.25rem",
      buttonHeight: width <= 1023 ? "2.5rem" : "2rem",
      buttonMarginTop: buttonMarginTop,
      width: width <= 350 ? "319px" : "",
      overflowX: width <= 350 ? "scroll" : "",
      theadWidth: width <= 350 ? "451px" : "100%",
      theadPaddingBottom: width <= 1023 ? "5px" : "",
      paddingBottom: width <= 1023 ? "10px" : "",
      paymentDateMarginTop: width >= DESKTOP ? "0rem" : "0.625rem",
      fontSize: width <= 1023 ? "0.75rem" : "0.625rem",
      paymentStatusPaddingBottom: width <= 1023 ? "13px" : "",
      wrapperWidth: width < TABLET && "100%",
    };
  };

  const {
    paddingTopValue,
    fontSize,
    okButtonWidth,
    buttonHeight,
    buttonMarginTop,
    width,
    overflowX,
    theadWidth,
    paddingBottom,
    theadPaddingBottom,
    paymentDateMarginTop,
    paymentStatusPaddingBottom,
    wrapperWidth,
  } = getResponsiveValues(windowWidth);

  const isApply = props.searchOrRefresh === true;
  const buttonId = isApply ? "payment-date-apply-button" : "payment-date-reset-button";
  const buttonOnClick = isApply ? handleDateRange : handleDateReset;
  const buttonLabel = t(isApply ? "APPLY" : "RESET");

  const filterButton = (
    <CPButton
      id={buttonId}
      boxButton={true}
      marginTop={buttonMarginTop}
      height={buttonHeight}
      secondary={true}
      onClick={buttonOnClick}
      width={wrapperWidth}
      fontSize="14px"
      fontPaddingLeft="0rem"
      fontPaddingRight="0rem"
    >
      {buttonLabel}
    </CPButton>
  );

  function getPaymentHeaderId(type, userLanguage) {
    const idMap = {
      "invoice-number": {
        "en-US": "invoice-number-payment-header-en-US",
        "nl-NL": "invoice-number-payment-header-nl-NL",
        "de-DE": "invoice-number-payment-header-de-DE",
        "fr-FR": "invoice-number-payment-header-fr-FR",
      },
      "payment-received": {
        "en-US": "payment-received-header-en-US",
        "nl-NL": "payment-received-header-nl-NL",
        "de-DE": "payment-received-header-de-DE",
        "fr-FR": "payment-received-header-fr-FR",
      },
      "payment-date": {
        "en-US": "payment-date-header-en-US",
        "nl-NL": "payment-date-header-nl-NL",
        "de-DE": "payment-date-header-de-DE",
        "fr-FR": "payment-date-header-fr-FR",
      },
      "payment-status": {
        "en-US": "payment-status-header-en-US",
        "nl-NL": "payment-status-header-nl-NL",
        "de-DE": "payment-status-header-de-DE",
        "fr-FR": "payment-status-header-fr-FR",
      },
    };
    return idMap[type]?.[userLanguage] || "";
  }

  function getAriaSort(sortStatus) {
    return sortStatus === "noSort" ? "other" : sortStatus;
  }

  function renderSortIcon(sortStatus) {
    if (sortStatus === "ascending") {
      return <SortIconStyle1 alt="ascending-icon" src={AscendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    }
    if (sortStatus === "descending") {
      return <SortIconStyle1 alt="descending-icon" src={DescendingSortIcon} aria-hidden="true" tabIndex="-1" />;
    }
    return <SortIconStyle alt="search-icon" src={NoSort} aria-hidden="true" tabIndex="-1" />;
  }

  function getPaymentTableId(type, userLanguage) {
    const idMap = {
      "invoice-number": {
        "en-US": "invoice-number-payment-data-en-US",
        "nl-NL": "invoice-number-payment-data-nl-NL",
        "de-DE": "invoice-number-payment-data-de-DE",
        "fr-FR": "invoice-number-payment-data-fr-FR",
      },
      "payment-amount": {
        "en-US": "payment-amount-data-en-US",
        "nl-NL": "payment-amount-data-nl-NL",
        "de-DE": "payment-amount-data-de-DE",
        "fr-FR": "payment-amount-data-fr-FR",
      },
      "payment-date": {
        "en-US": "payment-date-data-en-US",
        "nl-NL": "payment-date-data-nl-NL",
        "de-DE": "payment-date-data-de-DE",
        "fr-FR": "payment-date-data-fr-FR",
      },
      "payment-status": {
        "en-US": "payment-status-data-en-US",
        "nl-NL": "payment-status-data-nl-NL",
        "de-DE": "payment-status-data-de-DE",
        "fr-FR": "payment-status-data-fr-FR",
      },
      "payment-accordian": {
        "en-US": "payment-accordian-data-en-US",
        "nl-NL": "payment-accordian-data-nl-NL",
        "de-DE": "payment-accordian-data-de-DE",
        "fr-FR": "payment-accordian-data-fr-FR",
      },
    };
    return idMap[type]?.[userLanguage] || "";
  }

  return (
    <React.Fragment>
      <Loader active={props.loader} fullscreen={true} />
      <div>
        <ModalBox
          ariaLabel=""
          opened={props.alertModal}
          closeButton={
            <Wrapper onClick={handleErrorModal} marginRight="1rem" marginLeft="auto">
              <Icon name="close" size="medium" color="#000000" style={{ cursor: "pointer", float: "right" }} />
            </Wrapper>
          }
          disableOutsideClick={true}
          paddingTop="2rem"
          modalBodyPaddingTop="0rem"
          modalFooterPaddingTop="2.4rem"
          modalFooterWidth="65%"
          lineHeight="1.35rem"
          height="18rem"
          maxHeight="50vh"
          width="35rem"
          maxWidth="35rem"
          mobHeight="38vh"
          mobMaxHeight="70vh"
          mobWidth="85vw"
          mobMaxWidth="90vw"
          mobPaddingTop="2rem"
          mobBodyPaddingTop="0rem"
        >
          <ModalBody>
            <Wrapper style={{ paddingTop: paddingTopValue }}>
              {t("We are unable to process your request for payment history. Please try again.")}
            </Wrapper>
          </ModalBody>
          <ModalFooter>
            <Wrapper marginLeft="auto" width={windowWidth < TABLET && "100%"}>
              <Button
                secondary
                size="large"
                onClick={() => {
                  setAlertState(false);
                  props.setAlertModal(false);
                }}
                width={okButtonWidth}
              >
                {t("OK")}
              </Button>
            </Wrapper>
          </ModalFooter>
        </ModalBox>
      </div>
      <CustomWrapper>
        <Wrapper
          role="form"
          aria-label="Date Range Filter"
          display="inline-flex"
          justifyContent="flex-end"
          width={windowWidth < TABLET && "100%"}
          style={{ gap: "16px", flexWrap: "nowrap" }}
          flexDirection={windowWidth < TABLET && "column"}
        >
          <div>
            <DateFilter
              labelText={t("From")}
              ariaLabelledby="DateFrom"
              ariaDescribedby="PaymentDate"
              date={handleDateTimeZone(props.dateFrom)}
              handleDateFilter={(value) => (value ? handleDateFrom(value) : props.setDateFrom(""))}
              placeHolder={t(getDateFormat(props.regionId))}
              inputWidth="inherit"
              marginRight={"0"}
            />
            <span style={{ fontWeight: "400", fontSize: "0.75rem", color: "#747474", fontFamily: "neue-haas-grotesk-text" }}>
              {" "}
              {`${t(getDateFormat(props.regionId))}`}
            </span>
          </div>
          <div>
            <DateFilter
              labelText={t("To")}
              ariaLabelledby="DateTo"
              ariaDescribedby="PaymentDate"
              date={handleDateTimeZone(props.dateTo)}
              handleDateFilter={(value) => (value ? handleDateTo(value) : props.setDateTo(""))}
              placeHolder={t(getDateFormat(props.regionId))}
              marginRight={"0"}
              inputWidth="inherit"
            />
            <span style={{ fontWeight: "400", fontSize: "0.75rem", color: "#747474", fontFamily: "neue-haas-grotesk-text" }}>
              {" "}
              {`${t(getDateFormat(props.regionId))}`}
            </span>
          </div>
        </Wrapper>
        <StyledTableCSS.FilterWrapper>{filterButton}</StyledTableCSS.FilterWrapper>
      </CustomWrapper>

      {windowWidth >= DESKTOP ? (
        <div style={{ width: width, overflowX: overflowX }}>
          <StyledTableCSS.TableWrapper aria-label="Payment history" ref={tableSearchRef} width={theadWidth}>
            <thead>
              <StyledTableCSS.TableHeaderContainer className="table-header" aria-label="Table Header" style={{ paddingBottom: theadPaddingBottom }}>
                <MediumTextTableHeader
                  className="tableHeaderStyle"
                  id={getPaymentHeaderId("invoice-number", props.userLanguage)}
                  aria-sort={getAriaSort(props.sortStatusInvoiceNo)}
                  aria-label="Invoice number"
                >
                  <button
                    id="payment-invoice-number"
                    className="sortableCol"
                    style={{ paddingBottom: paddingBottom }}
                    tabIndex="0"
                    onClick={() => tableSort("invoiceNumber", props.sortStatusInvoiceNo, "sortStatusInvoiceNo")}
                  >
                    {t("Invoice number")}
                    {renderSortIcon(props.sortStatusInvoiceNo)}
                  </button>
                </MediumTextTableHeader>

                <MediumTextTableHeader
                  style={{ paddingBottom: paddingBottom }}
                  className="tableHeaderStyle"
                  id={getPaymentHeaderId("payment-received", props.userLanguage)}
                >
                  {t("Payment received")}
                </MediumTextTableHeader>

                <MediumTextTableHeader
                  className="tableHeaderStyle"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: paymentDateMarginTop,
                  }}
                  id={getPaymentHeaderId("payment-date", props.userLanguage)}
                >
                  {t("Payment date")}

                  {windowWidth <= 1023 ? (
                    <span style={{ fontSize: fontSize, fontWeight: "bold", paddingBottom: "5px" }}>{` [${t(getDateFormat(props.regionId))}]`}</span>
                  ) : null}
                </MediumTextTableHeader>

                {windowWidth >= 481 && (
                  <MediumTextTableHeader
                    className="tableHeaderStyle"
                    aria-sort={getAriaSort(props.sortStatusPaymentStatus)}
                    aria-label="Payment status"
                    id={getPaymentHeaderId("payment-status", props.userLanguage)}
                  >
                    <button
                      style={{ paddingBottom: paymentStatusPaddingBottom }}
                      id="payment-status-button"
                      className="sortableCol"
                      tabIndex="0"
                      onClick={() => tableSort("paymentStatus", props.sortStatusPaymentStatus, "sortStatusPaymentStatus")}
                    >
                      {t("Payment status")}
                      {renderSortIcon(props.sortStatusPaymentStatus)}
                    </button>
                  </MediumTextTableHeader>
                )}
              </StyledTableCSS.TableHeaderContainer>
            </thead>

            <tbody>
              {props.tableData.length !== 0 ? (
                props.tableData.map((history, index) => (
                  <>
                    <StyledTableCSS.PaymentTableContainer className="table-body" key={history.transactionNumber}>
                      <MediumTextTableBody
                        className="tableHeaderStyle"
                        style={{ wordWrap: "break-word" }}
                        id={getPaymentTableId("invoice-number", props.userLanguage)}
                      >
                        {history.invoiceNumber}
                      </MediumTextTableBody>
                      <MediumTextTableBody
                        className="tableHeaderStyle"
                        style={{ wordWrap: "break-word" }}
                        id={getPaymentTableId("payment-amount", props.userLanguage)}
                      >
                        {addCurrencySymbol(history.paymentAmount, props.currencySymbol)}
                      </MediumTextTableBody>
                      <MediumTextTableBody
                        className="tableHeaderStyle"
                        style={{ wordWrap: "break-word" }}
                        id={getPaymentTableId("payment-date", props.userLanguage)}
                      >
                        {history.paymentDate}
                      </MediumTextTableBody>
                      {windowWidth >= 481 ? (
                        <MediumTextTableBody
                          className="tableHeaderStyle"
                          style={{ wordWrap: "break-word" }}
                          id={getPaymentTableId("payment-status", props.userLanguage)}
                        >
                          {t(`${history.paymentStatus}`)}
                        </MediumTextTableBody>
                      ) : (
                        <MediumTextTableBody style={{ width: "7%" }} id={getPaymentTableId("payment-accordian", props.userLanguage)}>
                          <div style={{ float: "right" }}>
                            <ArrowIconStyle
                              tabIndex="0"
                              src={accordianArray.includes(history.accordianId) ? UpArrowIcon : DownArrowIcon}
                              onClick={() => handleAccordianChange(history.accordianId)}
                            />
                          </div>
                        </MediumTextTableBody>
                      )}
                    </StyledTableCSS.PaymentTableContainer>
                    {windowWidth < TABLET && (
                      <>
                        {accordianArray.includes(history.accordianId) && (
                          <StyledTableCSS.PaymentTableContainer>
                            <StyledTableCSS.AccordianDiv>
                              <StyledTableCSS.AccordianSpanHeader>{t("Payment status")}</StyledTableCSS.AccordianSpanHeader>
                              <StyledTableCSS.AccordianSpanBody>{t(`${history.paymentStatus}`)}</StyledTableCSS.AccordianSpanBody>
                            </StyledTableCSS.AccordianDiv>
                          </StyledTableCSS.PaymentTableContainer>
                        )}
                      </>
                    )}
                  </>
                ))
              ) : (
                <StyledTableCSS.PaymentTableContainer style={{ display: "block" }}>
                  {" "}
                  <td style={{ all: "unset" }}>
                    <h4
                      style={{
                        textAlign: "center",
                        fontFamily: "neue-haas-grotesk-text",
                        fontSize: props.windowSize.width >= DESKTOP ? "0.75rem" : "",
                      }}
                      role="row"
                      aria-label="No Records to display"
                    >
                      {t("No Records to display")}
                    </h4>
                  </td>
                </StyledTableCSS.PaymentTableContainer>
              )}
            </tbody>
          </StyledTableCSS.TableWrapper>
        </div>
      ) : (
        <Wrapper style={{ borderTop: "2.5px solid #000000" }} marginTop={windowWidth < TABLET ? "40px" : "24px"} ref={tableSearchRef}>
          {props.tableData.length !== 0 ? (
            props.tableData.map((history, index) => (
              <Grid colSizes={{ mobile: 2, tablet: 6 }} key={history.transactionNumber}>
                <StyledTableCSS.StyledRow>
                  <StyledTableCSS.LeftAlignedCol>{t("Invoice number")}</StyledTableCSS.LeftAlignedCol>
                  <StyledTableCSS.RightAlignedCol>{history.invoiceNumber}</StyledTableCSS.RightAlignedCol>
                </StyledTableCSS.StyledRow>
                <StyledTableCSS.StyledRow>
                  <StyledTableCSS.LeftAlignedCol>{t("Payment received")}</StyledTableCSS.LeftAlignedCol>
                  <StyledTableCSS.RightAlignedCol>{addCurrencySymbol(history.paymentAmount, props.currencySymbol)}</StyledTableCSS.RightAlignedCol>
                </StyledTableCSS.StyledRow>
                <StyledTableCSS.StyledRow>
                  <StyledTableCSS.LeftAlignedCol>{t("Payment date")}</StyledTableCSS.LeftAlignedCol>
                  <StyledTableCSS.RightAlignedCol>{history.paymentDate}</StyledTableCSS.RightAlignedCol>
                </StyledTableCSS.StyledRow>
                <StyledTableCSS.StyledRow>
                  <StyledTableCSS.LeftAlignedCol>{t("Payment status")}</StyledTableCSS.LeftAlignedCol>
                  <StyledTableCSS.RightAlignedCol>{t(`${history.paymentStatus}`)}</StyledTableCSS.RightAlignedCol>
                </StyledTableCSS.StyledRow>
                <Wrapper marginBottom="8px" marginTop="8px" borderTop={"1px solid #D8DADA"}></Wrapper>
              </Grid>
            ))
          ) : (
            <Wrapper>
              <Wrapper padding="8px 16px" style={{ borderBottom: "1px solid #d8dada", fontWeight: 700 }} aria-label="No Records to display">
                {t("No Records to display")}
              </Wrapper>
            </Wrapper>
          )}
        </Wrapper>
      )}
      {props.tableData.length !== 0 && (
        <StyledPaginationCSS.BillingBottom className="pagination" role="navigation" aria-label="pagination">
          <StyledPaginationCSS.RightDiv>
            <Icon
              id="payment-pagination-left-arrow"
              name="left-arrow"
              size="small"
              color="#000000"
              style={{ fontWeight: "bold" }}
              backgroundColor="transparent"
              aria-hidden="true"
              tabIndex="-1"
            />
            <Pagination
              activePage={props.activePage}
              itemsCountPerPage={props.recordsPerPage}
              totalItemsCount={props.totalNumberOfRecords}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={handlePageChange}
              prevPageText={t("Previous")}
              nextPageText={t("Next")}
              hideFirstLastPages="true"
              itemClassPrev="firstPage"
              itemClassNext="nextPage"
            />
            <Icon
              id="payment-pagination-right-arrow"
              name="right-arrow"
              size="small"
              color="#000000"
              style={{ fontWeight: "bold" }}
              backgroundColor="transparent"
              aria-hidden="true"
              tabIndex="-1"
            />
          </StyledPaginationCSS.RightDiv>
        </StyledPaginationCSS.BillingBottom>
      )}
    </React.Fragment>
  );
}
const mapDispatchToProps = {
  setTransactionList: Actions.setTransactionList,
  setActualTransactionList: Actions.setActualTransactionList,
  setTotalNumberOfRecords: Actions.setTotalNumberOfRecords,
  setActivePage: Actions.setActivePage,
  setShowModal: Actions.setShowModal,
  setAlertModal: Actions.setAlertModal,
  setRecordsPerpage: Actions.setRecordsPerpage,
  setPageCount: Actions.setPageCount,
  setSlicedData: Actions.setSlicedData,
  setFilteredData: Actions.setFilteredData,
  setPaymentTableData: Actions.setPaymentTableData,
  setActionName: Actions.setActionName,
  setFullSearchData: Actions.setFullSearchData,
  setDateFrom: Actions.setDateFrom,
  setDateTo: Actions.setDateTo,
  setSortStatusInvoiceNo: Actions.setSortStatusInvoiceNo,
  setSortStatusTransactionNo: Actions.setSortStatusTransactionNo,
  setSortStatusPaymentAmount: Actions.setSortStatusPaymentAmount,
  setSortStatusPaymentDate: Actions.setSortStatusPaymentDate,
  setSortStatusPaymentStatus: Actions.setSortStatusPaymentStatus,
  setSortStatusPaymentMode: Actions.setSortStatusPaymentMode,
  setSearchOrRefresh: Actions.setSearchOrRefresh,
  reset: Actions.reset,
  load: Actions.loadData,
  setLoader: Actions.setLoader,
};
const mapStateToProps = (state) => {
  return {
    contractAccount: state.BILLING.contractAccount,
    currencySymbol: state.BILLING.currencySymbol,
    makePaymentHistoryCall: state.PAYMENTHISTORY.makePaymentHistoryCall,
    transactionList: state.PAYMENTHISTORY.transactionList,
    actualTransactionList: state.PAYMENTHISTORY.actualTransactionList,
    totalNumberOfRecords: state.PAYMENTHISTORY.totalNumberOfRecords,
    activePage: state.PAYMENTHISTORY.activePage,
    showModal: state.PAYMENTHISTORY.showModal,
    alertModal: state.PAYMENTHISTORY.alertModal,
    recordsPerPage: state.PAYMENTHISTORY.recordsPerPage,
    pageCount: state.PAYMENTHISTORY.pageCount,
    slicedData: state.PAYMENTHISTORY.slicedData,
    filteredData: state.PAYMENTHISTORY.filteredData,
    tableData: state.PAYMENTHISTORY.tableData,
    actionName: state.PAYMENTHISTORY.actionName,
    selectedFilterBy: "paymentDate",
    fullSearchData: state.PAYMENTHISTORY.fullSearchData,
    dateFrom: state.PAYMENTHISTORY.dateFrom,
    dateTo: state.PAYMENTHISTORY.dateTo,
    sortStatusInvoiceNo: state.PAYMENTHISTORY.sortStatusInvoiceNo,
    sortStatusTransactionNo: state.PAYMENTHISTORY.sortStatusTransactionNo,
    sortStatusPaymentAmount: state.PAYMENTHISTORY.sortStatusPaymentAmount,
    sortStatusPaymentDate: state.PAYMENTHISTORY.sortStatusPaymentDate,
    sortStatusDuePaymentMode: state.PAYMENTHISTORY.sortStatusDuePaymentMode,
    sortStatusPaymentStatus: state.PAYMENTHISTORY.sortStatusPaymentStatus,
    searchOrRefresh: state.PAYMENTHISTORY.searchOrRefresh,
    loader: state.PAYMENTHISTORY.loader,
    windowSize: state.ACCOUNT.windowSize,
    regionId: state.ACCOUNT.regionId,
    userLanguage: state.ACCOUNT.userLanguage,
  };
};

ManagePaymentHistory.propTypes = {
  windowSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
  }).isRequired,
  userLanguage: PropTypes.string,
  sortStatusPaymentStatus: PropTypes.string,
  sortStatusInvoiceNo: PropTypes.string,
  loader: PropTypes.bool,
  regionId: PropTypes.string,
  paymentHistoryTab: PropTypes.number,
  contractAccount: PropTypes.string,
  makePaymentHistoryCall: PropTypes.bool,
  transactionList: PropTypes.array,
  filteredData: PropTypes.array,
  load: PropTypes.func,
  reset: PropTypes.func,
  setFilteredData: PropTypes.func,
  setPaymentTableData: PropTypes.func,
  actionName: PropTypes.string,
  recordsPerPage: PropTypes.number,
  activePage: PropTypes.number,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  setDateFrom: PropTypes.func,
  pageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setPageCount: PropTypes.func,
  setTotalNumberOfRecords: PropTypes.func,
  setDateTo: PropTypes.func,
  setSortStatusInvoiceNo: PropTypes.func,
  setActivePage: PropTypes.func,
  setActionName: PropTypes.func,
  currencySymbol: PropTypes.string,
  setSortStatusPaymentStatus: PropTypes.func,
  setSearchOrRefresh: PropTypes.func,
  searchOrRefresh: PropTypes.bool,
  alertModal: PropTypes.bool,
  setAlertModal: PropTypes.func,
  inputValue: PropTypes.string,
  setSortStatusTransactionNo: PropTypes.func,
  setSortStatusPaymentAmount: PropTypes.func,
  setSortStatusPaymentDate: PropTypes.func,
  setSortStatusPaymentMode: PropTypes.func,
  selectedFilterBy: PropTypes.string,
  tableData: PropTypes.array,
  totalNumberOfRecords: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagePaymentHistory);
